<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialog">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ nameGroup }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items />
        </v-toolbar>
        <v-divider />
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
            >
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="students"
                  :hide-default-footer="true"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :key="refreshList"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Listado de Estudiantes</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      />
                      <v-spacer />
                      <v-btn
                        outlined
                        color="primary"
                        @click="dialogGroupEmit('add', nameGroup)"
                      >
                        Agregar Estudiante
                      </v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-container>
                      <v-row>
                        <v-col cols="4">
                          <details-students :id="item.actions.id" />
                        </v-col>
                        <v-col cols="4">
                          <v-btn
                            color="warning"
                            dark
                            small
                            @click="updateStudent('edit', item.actions)"
                          >
                            Editar
                          </v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn
                            color="red"
                            dark
                            small
                            @click="updateStudent('del', item.actions)"
                          >
                            Quitar
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <invite-student
        :item="{nameGroup}"
        :invitation-type="invitationType"
      />
    </v-dialog>
    <v-dialog
      v-model="dialogOptionStudent"
      max-width="490"
    >
      <v-card>
        <v-form
          ref="form"
        >
          <div v-if="optionGroup === 'edit'">
            <v-card-title
              class="headline text-left mb-4"
            >
              Mover Estudiante
            </v-card-title>

            <v-card-text>
              <v-row
                justify="center"
              >
                <v-col
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <v-select
                    v-model="newGroup"
                    :items="groups"
                    label="Mover estudiante"
                    item-text="name"
                    outlined
                    :rules="groupNameRules"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </div>
          <div v-if="optionGroup === 'del'">
            <v-card-title

              class="headline text-left mb-4"
            >
              Quitar Estudiante
            </v-card-title>
            <v-card-text>
              <p>
                ¿Está seguro/a de que quiere quitar al estudiante del grupo: <strong> {{ nameGroup }} </strong>?
              </p>
            </v-card-text>
          </div>

          <v-card-actions>
            <v-spacer />

            <v-btn
              color="green darken-1"
              text
              @click="close"
            >
              Cancelar
            </v-btn>

            <v-btn
              v-if="optionGroup === 'edit'"
              color="green darken-1"
              text
              @click="changeGroup"
            >
              Actualizar
            </v-btn>
            <v-btn
              v-if="optionGroup === 'del'"
              color="green darken-1"
              text
              @click="deleteStudent"
            >
              Quitar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import DetailsStudents from '@/views/dashboard/pages/panel/DetailsStudents'
  import InviteStudent from '@/views/dashboard/invitations/InviteStudent'

  export default {
    components: {
      DetailsStudents,
      InviteStudent,
    },
    props: {
      view: {
        type: Boolean,
      },
      dialogGroup: {
        type: Function,
        default: () => {},
      },
    },
    data () {
      return {
        invitationType: 'byGroup',
        headers: [
          { text: 'Nombre', value: 'firstname', sortable: false },
          { text: 'Apellido', value: 'lastname', sortable: false },

          { text: 'Última conexión', value: 'last_sign_in', sortable: false },
          { text: 'Acciones', value: 'actions', align: 'center', sortable: false },
          // { text: 'Promedio global', value: 'average' },
        ],
        dialogOptionStudent: false,
        studentSelected: null,
        optionGroup: '',
        groupIndexCurrent: 0,
        studentId: null,
        groupNameRules: [
          v => !!v || 'Nombre de grupo es requerido',
          v => v !== this.nameGroup || 'Seleccione un grupo distinto',
        ],
        newGroup: '',
        sortBy: 'lastname',
        sortDesc: false,
        refreshList : false
      }
    },
    computed: {
      ...mapState(['userData', 'dataGroupSelected']),
      ...mapGetters(['getDataGroupSelected']),
      dialog: {
        get: function () {
          return this.view
        },
        set: function (newValue) {
          this.$emit('update', newValue)
        },
      },
      nameGroup () {
        return this.getDataGroupSelected.name
      },
      students () {
        return this.getDataGroupSelected.students

        this.refreshList = true

        this.$refs.form1.reset()
        //return this.getDataGroupSelected
      },
      groups () {
        return this.userData.groups
      },
      newGroupIndex () {
        return this.groups.findIndex(g => g.name === this.newGroup)
      },
    },
    methods: {
      close () {
        this.dialogOptionStudent = false

      },
      updateStudent (val, action) {
        this.studentSelected = action
        this.optionGroup = val
        this.studentId = action.id
        this.groupIndexCurrent = action.groupIndex
        this.newGroup = this.nameGroup
        this.dialogOptionStudent = true
      },
      changeGroup () {
        if (this.$refs.form.validate()) {
          const groups = this.groups
          const student = this.students.findIndex(s => s.actions.id === this.studentId)
          this.students.splice(student, 1)
          const indexStudent = groups[this.groupIndexCurrent].students.indexOf(this.studentId)
          groups[this.groupIndexCurrent].students.splice(indexStudent, 1)

          groups[this.newGroupIndex].students.push(this.studentId)
          this.$store.dispatch('EDIT_GROUP', groups)
          // this.$emit('updateDetailsGroup', this.nameGroup)

          this.close()
        } else {
          console.log('Faltan datos')
        }
      },
      deleteStudent () {
        if (this.$refs.form.validate()) {
          const groups = this.groups
          const student = this.students.findIndex(s => s.actions.id === this.studentId)
          this.students.splice(student, 1)
          const indexStudent = groups[this.groupIndexCurrent].students.indexOf(this.studentId)
          groups[this.groupIndexCurrent].students.splice(indexStudent, 1)

          this.$store.dispatch('EDIT_GROUP', groups)
          this.close()
        } else {
          console.log('Faltan datos')
        }
      },
      dialogGroupEmit (type, name) {
        this.$emit('dialogGroup', type, name)
      },
    },
  }
</script>
